(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSProyectoController', SSProyectoController);

    SSProyectoController.$inject = ['$state', 'SSProyecto', 'ParseLinks', 'entity', 'SSPeriodo', 'SolicitudDownloadService', 'AcuseDownloadService'];

    function SSProyectoController($state, SSProyecto, ParseLinks, entity, SSPeriodo, SolicitudDownloadService, AcuseDownloadService) {

        var vm = this;
        vm.searchForm = {};
        vm.search = search;
        vm.proyectoDetalle = proyectoDetalle;
        vm.proyectoSeguimiento = proyectoSeguimiento;
        vm.proyectoImprimir = proyectoImprimir;
        vm.proyectoAcuse = proyectoAcuse;
        vm.proyectoEliminar = proyectoEliminar;
        
        entity.$promise.then(function(periodos) {
        	vm.periodos = periodos;
        	vm.selectedPeriodo = periodos[0];
        	loadProyectos();
        });

        function search() {
            	loadProyectos();
        }

        function loadProyectos(){
        	SSProyecto.getByPrestador({
	        	fechaIniPer: vm.selectedPeriodo.iniPeriodo,
	        	fechaFinPer: vm.selectedPeriodo.finPeriodo,
        	}).$promise.then(function(proyectos) {
	        	vm.sSProyectos = proyectos;
	        });         	
        }
        
        function proyectoDetalle(idProyecto, propagation, $event){
        	$state.go('ss-proyecto-solicitud',{id: idProyecto});
        	if(propagation == false){
        		$event.stopPropagation();        		
        	}
        }
        
        function proyectoSeguimiento(idProyecto, propagation, $event){
        	$state.go('ss-proyecto-seguimiento',{id: idProyecto});
        	if(propagation == false){
        		$event.stopPropagation();        		
        	}
        }
        
        function proyectoImprimir(idProyecto, propagation, $event){
        	SolicitudDownloadService.download(idProyecto);
        	if(propagation == false){
        		$event.stopPropagation();        		
        	}
        }
        
        function proyectoAcuse(idProyecto, propagation, $event){
        	AcuseDownloadService.download(idProyecto);
        	if(propagation == false){
        		$event.stopPropagation();        		
        	}
        }
        
        function proyectoEliminar(idProyecto, propagation, $event){
        	$state.go('ss-proyectos-delete',{id: idProyecto});
        	if(propagation == false){
        		$event.stopPropagation();        		
        	}
        }
    }
})();
